<template>
  <div class='opc-succezz-thx'>
    <div class='opc-succezz-thx__status'>
      <img src='@/assets/success/confirmation_check.svg' alt=''>
    </div>
    <h1 class='opc-succezz-thx__title' :aria-label='title || displayTitle'>{{ title || displayTitle }}</h1>
    <div class='opc-succezz-thx__sub-title'>
      <span v-if="isAPM" v-html="apmSubtitle"></span>
      <span v-else v-html="$t('billing.success.confirmation.receive_a_confirmation_email', [`<b style='font-weight: 600'>${email}</b>`])"></span>
      <slot name='subtitle'></slot>
    </div>
    <div class='opc-succezz-thx__actions'>
      <slot v-if='$slots.default'></slot>
      <template v-else>
        <view-account />
      </template>
    </div>
    <div v-if='$slots.reminder' class='opc-succezz-thx__reminder'>
      <slot name='reminder'></slot>
    </div>
    <partner-promote />
  </div>
</template>

<script>
import { APM_PAYMENT_METHODS } from '@/common/constants';
import { mapGetters } from 'vuex';
import PartnerPromote from '@/views/succezz/components/partner-promote.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';

export default {
  components: {
    ViewAccount,
    PartnerPromote,
  },
  props: {
    email: {
      type: String,
      default: window?.SB?.user?.email,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['persistState']),
    apmSubtitle() {
      if (this.persistState.confirmationDetails?.apmName === APM_PAYMENT_METHODS.FURIKOMI) {
        return this.$t('billing.bank_transfer.message', [5, `<b style='font-weight: 600'>${this.email}</b>`]);
      }
      return this.$t('billing.success.process_payment_once_verified', [`<b style='font-weight: 600'>${this.email}</b>`]);
    },
    isAPM() {
      return !!this.persistState.confirmationDetails?.isAPM;
    },
    displayTitle() {
      if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.buyTrial) {
        return this.title || this.$t('billing.success.confirmation.thank_you_for_choosing_zoom');
      }
      return this.title || this.$t('billing.success.update_success_plan');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '@/styles/responsive.scss';
@import '@/styles/_variables.scss';

.opc-succezz-thx {
  position: relative;

  &__status {
    font-size: 36px;
    color: #95ebb2;
    margin-bottom: 12px;
  }

  &__title {
    font-family: Happy Display;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  &__sub-title {
    font-family: Almaden Sans;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    margin-top: 6px;
    word-break: break-word;

    span + span {
      margin-left: 4px;
    }
  }

  &__actions {
    margin-top: 24px;
    .zm-button.zm-button--primary.zm-button--large.is-round  {
      min-width: unset;
      padding: 8px 24px;
      border-radius: 24px;
    }

    .zm-button.zm-button--large.zm-button--plain {
      line-height: 24px;
    }

    @include media(mobile, tablet) {
      /deep/ .zm-button {
        width: 100%;
        padding: $mobile-space/2;
        border-radius: $mobile-space;
      }

      /deep/ .zm-button+.zm-button {
        margin-left: 0px;
        margin-top: $mobile-space/2;
      }
    }
  }

  &__reminder {
    margin-top: 24px;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
